import SideMenu from "../../features/sideMenu/SideMenu";
import Clients from "./Clients";
import { itemsProjects } from "../../constants/projects";
import "./ClientsPage.responsive.css";

const ClientsPage = ({ API_URL, perfiles, clients }) => {
  return (
    <div
      className="clientsPage-container"
      style={{ display: "flex", width: "100%" }}
    >
      <div className="clientsPage-sidebar">
        <SideMenu items={itemsProjects} />
      </div>
      <div
        className="clientsPage-main"
        style={{ flex: 1, padding: "10px", width: "100%" }}
      >
        <Clients API_URL={API_URL} clients={clients} perfiles={perfiles} />
      </div>
    </div>
  );
};

export default ClientsPage;
